<div class="container">
  <div *ngIf="displayCloseButton" class="close" (click)="closeClicked()"></div>
  <div class="steps" [ngClass]="stepsClass">
    <div *ngFor="let step of steps; index as i">
      <div [ngClass]="{'numberCircle': stepsCount > 2, 'numberCirclePurple': stepsCount  < 3, 'standard-background-color': isStandardColors}" [class.active-step]="step === currentStep">{{step}}</div>
      <hr *ngIf="step < stepsCount" class="horizontal-line" />
    </div>
  </div>
</div>
